import { render, staticRenderFns } from "./registProfile.vue?vue&type=template&id=28f95ff8&"
import script from "./registProfile.vue?vue&type=script&lang=js&"
export * from "./registProfile.vue?vue&type=script&lang=js&"
import style0 from "./registProfile.vue?vue&type=style&index=0&id=28f95ff8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports